import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";
import { CSVLink } from "react-csv";

function OPATemplateDownload() {
    const headers = [
        { label: 'AccountNumber', key: 'accountNumber' },
        { label: 'Period', key: 'period' },
        { label: 'Year', key: 'year' },
        { label: 'Amount', key: 'amount' },
        { label: 'Reason', key: 'reason' }
    ];

    // Example row to show expected format
    const templateData = [
        {
            accountNumber: 'ABC-12345',
            period: '1',
            year: '2025',
            amount: '1000.00',
            reason: 'Payer ReClass'
        }
    ];

    return (
        <React.Fragment>
            <CSVLink 
                data={templateData} 
                headers={headers} 
                filename={'opa-import-template.csv'} 
                className='btn' 
                style={{ margin: '0px', padding: '0px', textDecoration: 'none' }}
            >
                <Button variant='outlined' color='primary' startIcon={<Download />}>
                    Download Template
                </Button>
            </CSVLink>
        </React.Fragment>
    );
}

export { OPATemplateDownload };
